


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyCXR_joR6fqLbXuwMoYeTK7vQkRJtHCuNs",
  authDomain: "kalmunai-batticaloa-opticals.firebaseapp.com",
  projectId: "kalmunai-batticaloa-opticals",
  storageBucket: "kalmunai-batticaloa-opticals.firebasestorage.app",
  messagingSenderId: "409897883528",
  appId: "1:409897883528:web:85feaf79e08cc1eb314c3d"
};


const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export